export default {
      id: "cup-usage",
      viewBox: "0 0 72.69 54.52",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#cup",
      toString: function () {
        return this.url;
      }
    }